import { styled } from 'styled-components';
import { color, flexbox, grid, layout, position, space, typography, } from 'styled-system';
import { font as fontFn, ignoredProps } from '@design-system/theme';
export const Box = styled.div
    .withConfig({
    shouldForwardProp: (prop) => ![...ignoredProps, 'dataTestId'].includes(prop),
})
    .attrs(({ 'data-testid': testid, dataTestId, display = 'flex', font = 'body-regular-asphalt', }) => ({
    'data-testid': testid || dataTestId,
    display,
    font,
})) `
  // Keep this order
  ${position}
  ${flexbox}
  ${fontFn}
  ${layout}
  ${space}
  ${typography}
  ${color}
  ${grid}
`;
//# sourceMappingURL=Box.js.map